import { Button } from '@gr-monorepo/common/ui';
import styled from 'styled-components';

export const StateButtonStyled = styled(Button)`
  padding: 6px 12px;
  text-transform: none;
  width: fit-content;
  display: flex;

  svg {
    display: block;
  }

  &.current {
    color: #9965f4;
    background-color: #ede0f8;
  }

  &.future {
    color: #09152680;
    background-color: #e9e9e9;
  }
`;
